<template>
  <div
    class="bg-ontick-carbon-500 fixed inset-0 flex items-center justify-center"
  >
    <div class="mx-12 flex flex-col gap-4 md:justify-center">
      <i v-html="$icons.ordemRejeitada" class="text-ontick-red-600"></i>
      <div class="flex flex-col gap-2">
        <h1 class="text-ontick-red-600 text-2xl font-bold">Erro</h1>
        <p>Ocorreu um erro no carregamento. Tente recarregar a página.</p>
        <button
          class="bg-ontick-steel-500 btn-shadow mt-2 flex h-10 items-center justify-center gap-2 rounded-lg text-sm font-semibold"
          @click="refresh"
        >
          <i v-html="$icons.refresh"></i>
          <span> Recarregar </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    refresh() {
      location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-shadow {
  box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.35);
}
</style>
